module.exports = __webpack_public_path__ + "static/media/preferral_logo_small.808bfe48.png";